__turbopack_context__.v({
  "cls1": "IconTarget-module__W3E4mW__cls1",
  "cls2": "IconTarget-module__W3E4mW__cls2",
});
